module.exports = __webpack_public_path__ + "static/img/naniungo-slide-13.d8152c06.jpg";